import { render, staticRenderFns } from "./BemText.vue?vue&type=template&id=0d984775&lang=pug"
import script from "./BemText.vue?vue&type=script&lang=js"
export * from "./BemText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports